import { render, staticRenderFns } from "./cPageDescription.vue?vue&type=template&id=15d6fede&scoped=true"
import script from "./cPageDescription.vue?vue&type=script&lang=js"
export * from "./cPageDescription.vue?vue&type=script&lang=js"
import style0 from "./cPageDescription.vue?vue&type=style&index=0&id=15d6fede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d6fede",
  null
  
)

export default component.exports